import { Button } from "src/apps/components/button/Button";
import { useTheme } from "src/apps/providers/ThemeStore";
import { OpenAdminAtomicBanner } from "./OpenAdminAtomicBanner";
import { OpenAdminLogos } from "./OpenAdminBannerShared";
import { useTranslations } from "src/apps/hooks/useTranslations";
import { BasicBannerProps } from "./OpenAdminBannerByStatus";

export const InitialOpenAdminBanner = ({
  title,
  description,
  buttonText,
  onButtonClick,
  isLoading = false,
  isDisabled = false,
}: BasicBannerProps) => {
  const { primaryColor } = useTheme();
  const { t } = useTranslations();

  return (
    <OpenAdminAtomicBanner
      title={t(title)}
      description={description ? t(description) : undefined}
      borderColor={primaryColor}
      leftComponent={<OpenAdminLogos />}
      rightComponent={
        buttonText ? (
          <Button
            onClick={onButtonClick ?? (() => {})}
            text={t(buttonText)}
            isLoading={isLoading}
            disabled={isDisabled}
          />
        ) : undefined
      }
    />
  );
};
